import AspectRatio from '@blocks/AspectRatio'
import EmphasizedContent from '@blocks/EmphasizedContent'
import Grid from '@blocks/Grid'
import { desktop } from '@styles/mixins'
import React from 'react'
import styled, { css } from 'styled-components'

export default function SalonLandingSection({ name, description, illustration_url }: Interfaces.Section) {
    return (
        <SectionContainer>
            <AspectRatio width={16} height={9}>
                <IllustrationWrapper url={illustration_url} />
            </AspectRatio>
            <EmphasizedContent>
                <Grid gap="5px">
                    <h4>{name}</h4>
                    {description.split('\n').map((item, idx) => <small key={idx}>{item}</small>)}
                </Grid>
            </EmphasizedContent>
        </SectionContainer>
    )
}

// STYLES
const SectionContainer = styled.div`
    width: 100%;
    display: grid;
    grid-row-gap: 20px;
    grid-column-gap: 60px;

    ${desktop(css`
        grid-template-rows: repeat(2, auto);
        align-items: center;
    `)}
`

const IllustrationWrapper = styled.div<{ url: string }>`
    width: 100%;
    height: 100%;
    background: ${props => `url(${props.url}) center no-repeat`};
    background-size: cover;
    border-radius: 10px;
`